import { ColourVariant } from '@weareopenr/component-library';
import { DayOfWeek } from '@weareopenr/types';
import { ITimetableDetail, ITimetableSchedule } from 'src/api/getTimetable';
import { DAY_OF_WEEK_ORDER, getEntityId, isDefaultSchedule, isMenuSchedule, isPriceSchemeSchedule } from './helpers';
import { getDayPercents } from './getDayPercents';
import { resolveScheduleColour } from './resolveScheduleColour';

export interface ITimetableDaySchedule {
  scheduleId: string;
  entityId: string;
  name: string;
  startTime: string;
  endTime: string;
  dayPercent: number;
  isDefault: boolean;
  colour: ColourVariant;
}

export interface ITimetableDay {
  day: DayOfWeek;
  menus: ITimetableDaySchedule[];
  priceSchemes: ITimetableDaySchedule[];
}

const byStartTime = (a: ITimetableSchedule, b: ITimetableSchedule): number => a.start_time.localeCompare(b.start_time);

const buildTimetableDaySchedules = (
  schedules: ITimetableSchedule[],
  timetable: ITimetableDetail,
): ITimetableDaySchedule[] => {
  const sorted = [...schedules].sort(byStartTime);
  const dayPercents = getDayPercents(
    sorted.map((schedule) => ({ startTime: schedule.start_time, endTime: schedule.end_time })),
  );

  return sorted.map((schedule, index) => {
    const isDefault = isDefaultSchedule(schedule, timetable);

    return {
      scheduleId: schedule.schedule_id,
      entityId: getEntityId(schedule),
      name: schedule.name,
      startTime: schedule.start_time,
      endTime: schedule.end_time,
      dayPercent: dayPercents[index],
      isDefault,
      colour: resolveScheduleColour(schedule.colour_order, isDefault),
    };
  });
};

export const groupSchedulesByDay = (timetable: ITimetableDetail): ITimetableDay[] =>
  DAY_OF_WEEK_ORDER.map((day) => {
    const schedulesForDay = timetable.schedules.filter((schedule) => schedule.day_of_week === day);

    return {
      day,
      menus: buildTimetableDaySchedules(schedulesForDay.filter(isMenuSchedule), timetable),
      priceSchemes: buildTimetableDaySchedules(schedulesForDay.filter(isPriceSchemeSchedule), timetable),
    };
  });
